import React from 'react';
import { useParams } from 'react-router-dom';
import DocumentosFuncionarioSection from './DocumentosFuncionarioSection';

const DocumentosFuncionarioPage = () => {
  const { id } = useParams();

  return (
    <div className="p-6">
      <DocumentosFuncionarioSection funcionarioId={id} />
    </div>
  );
};

export default DocumentosFuncionarioPage;
